import type { ProductLabelData } from "@/components/supply/ProductLabelPrintSheet.types";
import { LabelPrintPreview } from "@/components/supply/LabelPrintPreview";
import { LabelPrintSettingsPanel } from "@/components/printing/LabelPrintSettingsPanel";
import { getLabelPrintFormat } from "@/core/printing/label-print-formats";
import { loadLabelPrintUserSettings } from "@/core/printing/label-print-settings";
import { useMemo, useState } from "react";

interface LabelPrintModalProps {
  open: boolean;
  label: ProductLabelData | null;
  title?: string;
  onClose: () => void;
}

export function LabelPrintModal({ open, label, title = "Impression étiquette", onClose }: LabelPrintModalProps) {
  const [settings, setSettings] = useState(() => loadLabelPrintUserSettings());
  const format = useMemo(
    () => getLabelPrintFormat(settings.formatId) ?? getLabelPrintFormat("60x40-180")!,
    [settings.formatId],
  );

  if (!open) return null;

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title h5">{title}</h2>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer" />
          </div>
          <div className="modal-body">
            <div className="row g-3">
              <div className="col-md-6">
                <LabelPrintSettingsPanel
                  label={label}
                  onSettingsChange={setSettings}
                  showAgentDownload
                />
              </div>
              <div className="col-md-6">
                {label ? (
                  <LabelPrintPreview label={label} format={format} rotation={settings.rotation} />
                ) : (
                  <p className="small text-muted mb-0">Article sans code-barres imprimable.</p>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
